import apiClient from "./apiClient";
const resource = "/reservation-merges";

export default {
  async getAll(params = {}) {
    return apiClient.get(`${resource}`, { params });
  },

  async getReservation(params = {}) {
    return apiClient.get(`${resource}/reservation`, { params });
  },

  async getBill(uuid) {
    return apiClient.get(`${resource}/${uuid}/bill`);
  },

  async payBill(data) {
    return apiClient.post(`${resource}/pay`, data);
  },
  
  async create(data) {
    return apiClient.post(`${resource}`, data);
  },

  async getById(uuid) {
    return apiClient.get(`${resource}/${uuid}`);
  },
  async update(uuid, data) {
    return apiClient.put(`${resource}/${uuid}`, data);
  },
  async delete(uuid) {
    return apiClient.delete(`${resource}/${uuid}`);
  },
};
